module.exports = __webpack_public_path__ + "img/analysofti-logo.16f3120f.png";